import gql from 'graphql-tag';

export default gql`
mutation insertImage($object: [images_insert_input!]!) {
  insert_images(objects: $object) {
    affected_rows
  }
}
`;
